import React from "react";
import { Box, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

import BaseCard from "../components/BaseCard";
import {
  LocationName,
  LocationTitleRow,
  PhlebotomyCardActionsRow,
  PhlebotomyPrimaryActionButton,
} from "../components/BaseCard.styles";

interface MobilePhlebotomyGetLabsCardProps {
  onSchedule: () => void;
}

const MobilePhlebotomyGetLabsCard: React.FC<
  MobilePhlebotomyGetLabsCardProps
> = ({ onSchedule }) => {
  const { t } = useTranslation();

  return (
    <BaseCard
      showBorder={false}
      actions={
        <PhlebotomyCardActionsRow
          sx={{
            justifyContent: "center",
            "& > .MuiButton-root:only-child": { marginLeft: 0 },
          }}
        >
          <PhlebotomyPrimaryActionButton
            variant="unity-primary"
            onClick={onSchedule}
            startIcon={<FontAwesomeIcon icon={faCalendar} />}
          >
            {t("phlebotomySearch.mobileOptions.getLabsAction")}
          </PhlebotomyPrimaryActionButton>
        </PhlebotomyCardActionsRow>
      }
    >
      <Box sx={{ width: "100%", textAlign: "center" }}>
        <LocationTitleRow sx={{ justifyContent: "center" }}>
          <LocationName sx={{ textAlign: "center" }}>
            {t("phlebotomySearch.mobileOptions.getLabsTitle")}
          </LocationName>
        </LocationTitleRow>
        <Typography variant="body2" color="text.secondary">
          {t("phlebotomySearch.mobileOptions.getLabsSupport")}
        </Typography>
      </Box>
    </BaseCard>
  );
};

export default MobilePhlebotomyGetLabsCard;
